import Vue from 'vue';

if(document.getElementById('js-search')) {
    Vue.component('search-index', require('@/components/Search/Index.vue').default);
    window.search = new Vue({
        name: "Search",
        el: '#js-search',
    });
}
